<div class="container-fluid spacer-top-navigation">
  <div class="container row--primary kryptoonboarding">
    <div class="tile">
      <h2>Krypto-Wallet eröffnen - Vertrag abschließen</h2>
      <div class="row mt-4">
        <div class="col">
          <p>Unser Partner für die Verwahrung der Krypto-Assets (Kryptowährungen) und Anbieter der Wallet ist die Tangany GmbH.</p>

          <ul class="list-doc mt-2">
            <li>
              <a
                href="/assets/pdfs/20250218/krypto/tangany/Tangany_AGB.pdf"
                target="_blank"
                rel="noopener noreferrer"
                class="link-secondary text-default"
                >AGBs der Tangany GmbH</a
              >
            </li>
            <li>
              <a [href]="previewFileUrl$ | async" target="_blank" rel="noopener noreferrer" class="link-secondary text-default"
                >Gesonderte Vereinbarung zum Depotvertrag</a
              >
            </li>
            <li>
              <a [href]="contractPreviewFileUrl$ | async" target="_blank" rel="noopener noreferrer" class="link-secondary text-default"
                >Rahmenvertrag Anlage- und Abschlussvermittlung</a
              >
            </li>
          </ul>
          <p>Nach erfolgtem Abschluss findest Du die vollständigen Vertragsunterlagen auch in Deinem persönlichen Posteingang.</p>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-12 d-flex justify-content-center align-items-center">
          <web-design-system-button
            size="large"
            [disabled]="(cryptoOnboardingFacade.authenticationFinished$ | async) || !!(cryptoOnboardingFacade.dataToAuthorize$ | async)"
            (click)="cryptoOnboardingFacade.acceptContract()"
          >
            Verträge verbindlich abschliessen
          </web-design-system-button>
        </div>
      </div>
    </div>

    @if (cryptoOnboardingFacade?.dataToAuthorize$ | async; as dataToAuthorize) {
      <div class="tile">
        <div class="row">
          <div class="col">
            <web-components-transaction-auth
              [payload]="dataToAuthorize"
              (transactionResult)="cryptoOnboardingFacade.handleAuthenticationResult($event)"
            />
          </div>
        </div>
      </div>
    }

    @if (messageService.hasMessages$ | async) {
      <div class="tile">
        <div class="row">
          <div class="col">
            <web-components-user-messages />
          </div>
        </div>
      </div>
    }
  </div>
</div>
